import UploadImage from 'components/commons/upload-image'
import ModalForm from 'components/commons/modal-form'
import { InlineError, Input } from 'avo-ui'
import icImageDefault from 'assets/images/ic-image-x.svg'

export const FormUploadImage = ({ show, onHideForm, dataUpload, onChangeForm, errorForm, onSubmit }) => {
    return (
        <ModalForm
            className={'!w-[750px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={'Upload Product Picture'}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <UploadImage
                    classNameImage={'!w-28 !h-28 border border-neutral-30'}
                    classNameButtonDelete={'!-top-1 !-right-2'}
                    id={'image-profile'}
                    caption={'Foto Produk'}
                    value={dataUpload?.url?.base64 || icImageDefault}
                    onChange={(value) => onChangeForm({ url: value })}
                />
                <InlineError className={'mt-2 mx-auto'} message={errorForm?.url} />
                <div className={'flex space-x-16'}>
                    <div className={'flex-1 flex-col space-y-5'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Title</div>
                            <Input
                                className={'flex-1'}
                                name={'title'}
                                placeholder={'Masukkan title'}
                                value={dataUpload?.title}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.title} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Caption</div>
                            <Input
                                className={'flex-1'}
                                name={'caption'}
                                placeholder={'Masukkan caption'}
                                value={dataUpload?.caption}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Alt Text</div>
                            <Input
                                className={'flex-1'}
                                name={'alt_text'}
                                placeholder={'Masukkan alt text'}
                                value={dataUpload?.alt_text}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                        </div>
                    </div>
                    <div className={'flex-1 flex-col space-y-5'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Description</div>
                            <Input
                                type={'text-area'}
                                className={'flex-1'}
                                name={'description'}
                                placeholder={'Masukkan description'}
                                value={dataUpload?.description}
                                row={5}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalForm>
    )
}
